






















































import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getCurrentTimestamp
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import Button from '../../core/components/Button.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import Input from '../../core/components/Input.vue';
import { farmingTypeOptions, getFarmingKeyByType, getFarmingNameByType } from '../helpers';
import { dateTypes } from '../../core/models/date-models';

@Component({
    components: {
        Loading,
        SimpleMap,
        Combobox,
        Button,
        Input,
    }
})
export default class ModalAddVersionName extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() vehicleID: number;
    @Prop() farmingType: string;
    versionName: string = '';

    get getFarmingTypeName() {
        return this.farmingType === 'sowing' ? 'Siembra' : 'Cosecha';
    }

    updateVersionName(value){
        this.versionName = value;
    }
    
    @Emit()
    saveVersion() {
        return this.versionName
    }

    get getData() {
        return {
            
        };
    }

   
    get formIsValid() {
        if (this.versionName !== '') {
            return true;
        }
        
        return false;
        
    }

    @Emit()
    closeModal() {}

    preselectVersionName() {
        this.versionName = this.getFarmingTypeName
    }

    mounted() {
        this.preselectVersionName();
    }
}
